import { render, staticRenderFns } from "./SupervisorsView.vue?vue&type=template&id=cba2796e&scoped=true&"
import script from "./SupervisorsView.vue?vue&type=script&lang=js&"
export * from "./SupervisorsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba2796e",
  null
  
)

export default component.exports